import React from 'react';
import {Dimensions, Image, useColorScheme} from 'react-native';
import {RFValue} from 'react-native-responsive-fontsize';
import {createShimmerPlaceholder} from 'react-native-shimmer-placeholder';
import LinearGradient from 'react-native-linear-gradient';
import {useTheme} from 'styled-components/native';
import FontAwesome5 from 'react-native-vector-icons/FontAwesome5';

import {useNavigation} from '@react-navigation/native';

const ShimmerPlaceHolder = createShimmerPlaceholder(LinearGradient);
const SCREEN_W = Dimensions.get('window').width;
const SIDE_PAD = 24;

import {useCarrinhos} from '../../../../context/useCarrinhos';
import {Baratinhaz} from '../../../../components/Interface/Baratinhaz';

import {
  Wrapper,
  Background,
  TopRow,
  CarCol,
  CarImageWrapper,

  TitleCol,
  TitleRow,
  FuelIconBox,
  Title,
  Subtitle,
  SubtitleBold,
  StatsRow,
  StatCard,
  StatIconCircle,
  StatTextCol,
  StatValue,
  StatLabel,

} from './styles';

const CONQUISTAS_BG = require('../../../../assets/images/conquistas-bg.webp');

const CONQUISTAS_DARK = require('../../../../assets/images/conquistas-bg-dark.webp');

export function CarrinhoProgressCard() {
  const {navigate} = useNavigation<any>();
  const theme = useTheme();

  const isDark = useColorScheme() === 'dark';

  const {
    loading,
    error,
    currentCarImage,
    currentCarIndex,
    currentGanhoCompra,
    qtdLitrosMes,
    nextCar,
    remainingLitros,
    progress,

    carrosDisponiveis,
  } = useCarrinhos();

  if (loading) {
    const shimmerColors = theme.colors.shimmer_placeholder;
    return (
      <ShimmerPlaceHolder
        style={{
          marginHorizontal: SIDE_PAD,
          marginTop: RFValue(12),
          height: RFValue(180),
          borderRadius: RFValue(20),
          width: SCREEN_W - SIDE_PAD * 2,
        }}
        shimmerColors={shimmerColors}
      />
    );
  }

  if (error || carrosDisponiveis.length === 0) {
    return null;
  }

  const levelLabel = `Nível ${currentCarIndex + 1}`;
  const litrosMeta = nextCar ? nextCar.minimo_litros : qtdLitrosMes;

  const percentConcluido = Math.min(Math.round(progress * 100), 100);

  return (
    <Wrapper onPress={() => navigate('Achievements')} activeOpacity={0.8}>
      <Background source={isDark ? CONQUISTAS_DARK : CONQUISTAS_BG} imageStyle={{borderRadius: RFValue(20)}}>

        <TopRow>

          <CarCol>
            <CarImageWrapper>
              {currentCarImage && (
                <Image
                  source={currentCarImage}
                  style={{width: RFValue(90), height: RFValue(72), resizeMode: 'contain'}}
                />
              )}
            </CarImageWrapper>

          </CarCol>

          <TitleCol>
            <TitleRow>
              <FuelIconBox>
                <FontAwesome5 name="trophy" size={RFValue(14)} color={theme.colors.achievements_color} />
              </FuelIconBox>
              <Title numberOfLines={1}>{levelLabel}</Title>
              <FontAwesome5 name="arrow-right" size={RFValue(12)} color={theme.colors.achievements_color} />
            </TitleRow>
            <Subtitle>
              {nextCar ? (
                <>
                  Faltam <SubtitleBold>{remainingLitros} litros</SubtitleBold> para
                  desbloquear o <SubtitleBold>{nextCar.label}</SubtitleBold>
                </>
              ) : (
                'Você atingiu o nível máximo de conquistas!'
              )}
            </Subtitle>

          </TitleCol>
        </TopRow>

        <StatsRow>
          <StatCard>
            <StatIconCircle bg={theme.colors.achievements_bg}>
              <Baratinhaz width={RFValue(16)} height={RFValue(16)} />
            </StatIconCircle>
            <StatTextCol>
              <StatValue>+{currentGanhoCompra} btz</StatValue>
              <StatLabel>por retirada</StatLabel>
            </StatTextCol>
          </StatCard>

          <StatCard>
            <StatIconCircle bg={theme.colors.achievements_bg}>
              <FontAwesome5 name="gas-pump" size={RFValue(11)} color={theme.colors.achievements_color} />
            </StatIconCircle>
            <StatTextCol>
              <StatValue numberOfLines={1}>
                {qtdLitrosMes} L de {litrosMeta} L
              </StatValue>
              <StatLabel>{percentConcluido}% concluído</StatLabel>
            </StatTextCol>
          </StatCard>


        </StatsRow>


      </Background>
    </Wrapper>
  );
}
